module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-300.f31fbc04.ttf";